import { cn } from '@bem-react/classname';

export const cnApp = cn('App');

export namespace NApp {

    export interface Props {}
}